import { useEffect } from 'react';

import { isReactSnap } from '../../utils/env';

import { GoogleAdsProps } from './types';

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    adsbygoogle: any;
  }
}

export default function GoogleAdSense({
  slot,
  client,
  layout = '',
  layoutKey = '',
  format = 'auto',
  responsive = 'true',
}: GoogleAdsProps) {
  const isDev = isReactSnap();

  useEffect(() => {
    if (window && !isDev) {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  }, []);

  if (isDev) {
    return null;
  }

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block' }}
      data-ad-slot={slot}
      data-ad-client={client}
      data-ad-layout={layout}
      data-ad-format={format}
      data-ad-layout-key={layoutKey}
      data-full-width-responsive={responsive}
    />
  );
}
